 
import React from 'react';

const Users = () => {
  return (
    <div className="users-page">
      <h1>Users Management</h1>
      <p>Users list will be here...</p>
    </div>
  );
};

export default Users;